import { create } from 'zustand';

// ----------------------------------------------------------------------

const mediaPlayerStore = create((set) => ({
  play: true,
  muted: true,
  actions: {
    handlePlay: () => set((state) => ({ play: !state.play })),
    handleMuted: () => set((state) => ({ muted: !state.muted })),
  },
}));

export const useMediaPlayerStore = () => {
  const play = mediaPlayerStore((state) => state.play);
  const muted = mediaPlayerStore((state) => state.muted);
  const actions = mediaPlayerStore((state) => state.actions);

  return { play, muted, ...actions };
};
